import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { ExtrenalLinksForm } from './ExternalLinksAddOrUpdateForm';

type ExternalLinksDeleteForm = {
  form: ExtrenalLinksForm;
  refresh(): void;
};

export function ExternalLinksDeleteForm({ form, refresh }: ExternalLinksDeleteForm) {
  const { t } = useSonTranslation('ExternalLinks');

  return (
    <AcceptDeclineForm
      form={form as any}
      headline={t('deleteForm.question')}
      onSuccess={refresh}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
